/**
 * Solution Card Component
 *
 * Wires expand buttons on `.sc-card[data-solution]` to a shared fullscreen
 * panel (#sc-panel). Content is pulled from <template id="sc-content-{id}">.
 *
 * Keyboard: Escape closes the panel.
 */

(function (): void {
    const panel   = document.getElementById('sc-panel') as HTMLElement | null;
    if (!panel) return;

    const inner   = panel.querySelector<HTMLElement>('.sc-panel-inner');
    const backBtn = panel.querySelector<HTMLButtonElement>('.sc-back');
    if (!inner || !backBtn) return;

    const navbar = document.querySelector<HTMLElement>('.navbar');

    function openPanel(card: HTMLElement): void {
        const id  = card.dataset.solution;
        const tpl = document.getElementById(`sc-content-${id}`) as HTMLTemplateElement | null;
        if (!tpl) return;

        inner!.innerHTML = '';
        inner!.appendChild(tpl.content.cloneNode(true));

        panel!.setAttribute('aria-hidden', 'false');
        panel!.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        if (navbar) navbar.style.display = 'none';
        document.dispatchEvent(new CustomEvent('sc:panelopen'));
        backBtn!.focus();
    }

    function closePanel(): void {
        panel!.classList.remove('is-open');
        panel!.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (navbar) navbar.style.display = '';
    }

    document.querySelectorAll<HTMLElement>('.sc-card').forEach(function (card) {
        const btn = card.querySelector<HTMLElement>('.sc-expand');
        if (!btn) return;
        btn.addEventListener('click', function () { openPanel(card); });
    });

    backBtn.addEventListener('click', closePanel);

    document.addEventListener('keydown', function (e: KeyboardEvent) {
        if (e.key === 'Escape') closePanel();
    });
})();
